import React from 'react';
import { ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))


const DepartureList = React.lazy(() => import('pages/salary/DepartureList'));

const PF = '/insurance-tax'
const RoutesInsurance = [
    { path: `${PF}`, exact: true, name: '보험 및 세금' },
    { path: `${PF}/departure-guarantee`, exact: true, name: '출국만기보험내역', element: <DepartureList />, ...ADMIN_ACCESS },
    { path: `${PF}/departure-guarantee/detail`, exact: true, name: '상세', element: <NotFound />, ...ADMIN_ACCESS },
]

export default RoutesInsurance;
